class jfDetailsBar {

    constructor() {

    }

    getPubVer() {

        if (this.data) {
            let ver_obj = _.find(this.data, {'title': 'Latest Version'});
            if (ver_obj.content.public_version)
                return ver_obj.content.public_version;
            return 'N/A';
        }
    }

    isBuild(data) {

        return _.findIndex(data, {'title': 'CI Server'}) > -1;
    }

    hasWebsite(data) {

        return _.findIndex(data, {'title': 'website'});
    }

    getBuildIcon(name) {
        switch (name.toLowerCase()) {

            case 'jenkins':
            case 'hudson':
                this.hasBuildIcon = true;
                return 'images/jenkins.svg'
            case 'bamboo':
                this.hasBuildIcon = true;
                return 'images/bamboo.svg'
            case 'travis':
                this.hasBuildIcon = true;
                return 'images/travis.svg'
            case 'teamcity':
                this.hasBuildIcon = true;
                return 'images/teamcity.svg'
            default:
                this.hasBuildIcon = false;
                return '';
        }

    }

    getBuildName(data) {

        if (data[_.findIndex(data, {'title': 'CI Server'})].content.toLowerCase() === 'hudson')
            return 'Jenkins';

        if (data) {
            return _.capitalize(data[_.findIndex(data, {'title': 'CI Server'})].content);
        }
    }

    getTooltip(detail) {

        if (detail.title !== 'Latest Version' && detail.title !== 'Package Type') {
            return "";
        } else {
            /*     if (detail.title === 'Package Type') {
                if (detail.content.toLowerCase() == 'deb')
                    return "Debian"
                return _.capitalize(detail.content);
            }

             return 'Local: ' + detail.content.internal_version + '\n' + 'External: ' + this.getPubVer();*/
            return '';
        }
    }


}// class
export function jfDetailsBar() {

    return {
        restrict: 'E',
        scope: {

            data: '=?',

        },
        template: require('./jf_component_details_bar.html'),
        controller: jfDetailsBar,
        controllerAs: 'jfDetailsBar',
        bindToController: true
    }
}





// WEBPACK FOOTER //
// ./modules/xray/directives/jf_component_details_bar/jf_component_details_bar.js